module.exports = __webpack_public_path__ + "img/location-icon.51af1340.svg";